import { headersType } from "../../../models";
import { Service } from "../../../models/service.model";
import Button from "../../Button/Button";
import { TableHeader, TableRow } from "../../TableComponents/TableComponents";
import { SelectOption } from "../../Select/SelectNew";
import { annualPlanTypes } from "../../../screens/OfficePlan/planData";
import { SubscriptionType } from "../../../models/annual-plan.model";

export const toCamelCaseFromPascal = (str: string) => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

const Step4 = ({
  selectedPlans,
  monthlyOptions,
  yearlyOptions,
  services,
  patientNotifications,
  loading = false,
  changeStep,
}: {
  selectedPlans: any;
  services: Service[];
  monthlyOptions: SelectOption[];
  yearlyOptions: SelectOption[];
  patientNotifications: string;
  loading: boolean;
  changeStep: (val?: boolean) => void;
}) => {
  const header: headersType[] = [
    {
      title: "Plan",
      extraClasses: "w-full pl-0 pt-0 pb-0 break-all",
      sortKey: "",
      isClickable: false,
    },
    {
      title: "Rate",
      extraClasses: "w-full pl-0 pt-0 pb-0 break-all",
      sortKey: "frequency",
      isClickable: false,
    },
    {
      title: "Frequency",
      extraClasses: "w-full pl-0 pt-0 pb-0 break-all",
      sortKey: "rate",
      isClickable: false,
    },
  ];
  const extraClasses = header.map(head => head.extraClasses);
  return (
    <>
      <div className="mt-10">
        <h2 className="headline text-xl font-bold uppercase">Confirm Annual Plan Details</h2>
        <div className="mt-5">
          <h2 className="headline font-bold mb-3">Rates</h2>
          <div className="w-full relative">
            <div className="flex justify-between items-center border-b border-docnote-blue-light border-opacity-50">
              {header.map((head, index) => (
                <TableHeader
                  title={head.title}
                  index={index}
                  key={index}
                  sortIcon={null}
                  handleSort={() => null}
                  extraClassesHeader={head.extraClasses}
                  isClickable={head.isClickable}
                />
              ))}
            </div>
            {annualPlanTypes?.map((rowData, index) => {
              const price = [...monthlyOptions, ...yearlyOptions].find(
                item =>
                  item.value ===
                  selectedPlans[
                    `${toCamelCaseFromPascal(rowData.name)}Plan${
                      rowData.subscriptionType === SubscriptionType.Monthly ? "Monthly" : "Yearly"
                    }SubscriptionId`
                  ]
              );
              const sortedData = {
                name: <span className="text-ellipsis capitalize">{rowData.planName}</span>,
                price: price?.label,
                frequency: <span className="text-ellipsis capitalize">{rowData.subscriptionType}</span>,
              };
              return (
                <div className={`${!price && "hidden"}`} key={index}>
                  <TableRow
                    data={Object.values(sortedData)}
                    id={""}
                    tooltipVisible={false}
                    extraClassesRow={extraClasses}
                    handleOpenTooltip={() => null}
                    handleCloseTooltip={() => null}
                    tooltipOptions={[]}
                    handleTooltipClick={undefined}
                    onRowClick={() => null}
                    allowGroupHover={false}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="mt-5">
          <h2 className="headline font-bold">Services Included In Annual Plan:</h2>
          <div className="">
            <ul className="w-4/5">
              {services
                ?.filter(service => service.annualPlanEnabled)
                .map(service => {
                  return (
                    <li key={service.serviceId} className="flex justify-between pt-3">
                      <p>{service.name}</p>
                      <p>{service.annualPlanDiscountPct ?? "0"}%</p>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
        <div className="mt-5">
          <h2 className="headline font-bold">Annual Plan Description:</h2>
          <div className="ql-editor mt-2" dangerouslySetInnerHTML={{ __html: patientNotifications }} />
        </div>
      </div>
      <div className="fixed bottom-0 right-0 w-11/12 max-w-120 z-30 bg-docsigna-pink-light border-t">
        <div className="px-8 py-5 flex justify-end">
          <Button
            onClick={() => changeStep(true)}
            className="pointer px-5 mr-3"
            text={"Previous"}
            width="fit"
            variant="Secondary"
            disabled={loading}
          />
          <div id="save-button">
            <Button onClick={() => changeStep()} className="pointer px-5" text={"Save"} width="fit" variant={loading ? "loading" : "Primary"} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step4;
